import React, { Component } from "react";
import "./SampleVoterId.scss";
import VoterIDFront from "../../../assets/docSampleImages/VoterID FRONT.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Voter ID back.jpg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface ISampleVoterIDMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const SampleVoterIDMobileViewProps = (props: ISampleVoterIDMobileViewProps) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <span className="mobile-view-text">Uploading Voter ID</span>
        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Voter ID in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="voterId-Row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Voter ID Front" />
                  <div className="badge">1</div>
                </div>

                <span className="Aadhar-Label">FRONT</span>
              </span>
              <span className="Aadhar-Front-row ml-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Voter ID Back" />
                  <div className="badge">2</div>
                </div>

                <span className="Aadhar-Label">BACK</span>
              </span>
            </span>
          </span>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default SampleVoterIDMobileViewProps;
